const NS = 'cg:v1';

function key(...parts: string[]): string {
  return [NS, ...parts].join(':');
}

function safeGet(k: string): string | null {
  try {
    return localStorage.getItem(k);
  } catch {
    return null;
  }
}

function safeSet(k: string, v?: string | null): void {
  try {
    if (v === undefined || v === null || v === '') {
      localStorage.removeItem(k);      // ✅ hard delete
    } else {
      localStorage.setItem(k, v);
    }
  } catch {
    /* ignore */
  }
}

function uuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateVisitorId(agentId: string): string {
  const k = key('visitor', agentId);
  const existing = safeGet(k);
  if (existing) return existing;

  const id = uuid();
  safeSet(k, id);
  return id;
}

export function getActiveConversationId(
  agentId: string,
  visitorId: string
): string | null {
  const raw = safeGet(key('activeConversation', agentId, visitorId));

  // ✅ Normalize empty / invalid values
  if (!raw || raw === 'undefined' || raw === 'null') {
    return null;
  }

  return raw;
}

export function setActiveConversationId(
  agentId: string,
  visitorId: string,
  conversationId?: string | null
): void {
  // ✅ Passing undefined or null will fully clear storage
  safeSet(
    key('activeConversation', agentId, visitorId),
    conversationId
  );
}
